var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Paper, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, TablePagination, Container, CircularProgress, Typography, } from "@mui/material";
import Search from "../components/Search";
//import global css
import "../styles/global.css";
import { useIndexedDB } from "../hooks/clientStorage";
import { ClientDatabase, stores } from "../hooks/databaseConstants";
const SpeciesPage = () => {
    const [trials, setTrials] = useState([]);
    //db
    const { getAllValue, isDBConnecting, isDBPopulated } = useIndexedDB(ClientDatabase.name, stores.map((store) => store.name));
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    useEffect(() => {
        const fetchTrials = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!isDBConnecting && isDBPopulated) {
                const trialData = (yield getAllValue("trials"));
                //wait 2 seconds to simulate a slow connection
                //await new Promise((resolve) => setTimeout(resolve, 2000));
                setTrials(trialData);
                setLoading(false);
            }
        });
        fetchTrials();
    }, [isDBConnecting, getAllValue, isDBPopulated]);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    if (loading) {
        //material ui loading spinner
        //center the spinner verically and horizontally
        return (React.createElement(Container, { sx: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50vh",
            } },
            React.createElement(CircularProgress, null)));
    }
    // Filter trials based on the search term
    const filteredTrials = trials.filter((trial) => {
        const searchWords = searchTerm.split(" ");
        console.log({ trial });
        return (searchWords.reduce((acc, word) => {
            var _a, _b, _c, _d;
            if (trial.name.toLowerCase().startsWith(word.toLowerCase()) ||
                ((_a = trial.siteName) !== null && _a !== void 0 ? _a : "").toLowerCase().includes(word.toLowerCase()) ||
                //region starts with
                ((_b = trial.regionName) !== null && _b !== void 0 ? _b : "")
                    .toLowerCase()
                    .startsWith(word.toLowerCase()) ||
                //species
                ((_c = trial.speciesName) !== null && _c !== void 0 ? _c : "")
                    .toLowerCase()
                    .startsWith(word.toLowerCase()) ||
                //trial year
                ((_d = trial.trialYear) !== null && _d !== void 0 ? _d : "").toString().includes(word.toLowerCase())) {
                return acc + 1;
            }
            return acc;
        }, 0) > 0);
    });
    const paginatedTrials = filteredTrials.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const handleSearchTermChanged = (term) => {
        setSearchTerm(term);
    };
    return (React.createElement(Container, { maxWidth: false, sx: { width: "100%" } },
        React.createElement(Typography, { variant: "h4", gutterBottom: true }, "Trials by Species"),
        React.createElement(Search, { search: (term) => handleSearchTermChanged(term) }),
        React.createElement("br", null),
        React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, null,
                React.createElement(TableHead, { sx: { backgroundColor: "#f5f5f5", fontWeight: "bold" } },
                    React.createElement(TableRow, { className: "header-row" },
                        React.createElement(TableCell, null, "Trial Name"),
                        React.createElement(TableCell, null, "Region"),
                        React.createElement(TableCell, null, "Site"),
                        React.createElement(TableCell, null, "Species"),
                        React.createElement(TableCell, null, "Trial Year"),
                        React.createElement(TableCell, null, "Url"))),
                React.createElement(TableBody, null, paginatedTrials.map((trial) => {
                    var _a, _b, _c;
                    return (React.createElement(TableRow, { key: trial.id },
                        React.createElement(TableCell, null, trial.name),
                        React.createElement(TableCell, null, (_a = trial.regionName) !== null && _a !== void 0 ? _a : ""),
                        React.createElement(TableCell, null,
                            " ",
                            trial.siteName === "NULL" ? "" : trial.siteName),
                        React.createElement(TableCell, null, (_b = trial.speciesName) !== null && _b !== void 0 ? _b : ""),
                        React.createElement(TableCell, null, (_c = trial.trialYear) !== null && _c !== void 0 ? _c : ""),
                        React.createElement(TableCell, null, trial.trialDocument === "NULL" ? "" : trial.trialDocument)));
                }))),
            React.createElement(TablePagination, { rowsPerPageOptions: [5, 10, 25, 50], component: "div", count: filteredTrials.length, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage }))));
};
export default SpeciesPage;
